/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MailOffIcon16Light } from './MailOffIcon16Light';
import { MailOffIcon16Regular } from './MailOffIcon16Regular';
import { MailOffIcon16Solid } from './MailOffIcon16Solid';
import { MailOffIcon20Light } from './MailOffIcon20Light';
import { MailOffIcon20Regular } from './MailOffIcon20Regular';
import { MailOffIcon20Solid } from './MailOffIcon20Solid';
import { MailOffIcon24Regular } from './MailOffIcon24Regular';
import { MailOffIcon24Solid } from './MailOffIcon24Solid';
import { MailOffIcon32Regular } from './MailOffIcon32Regular';
import { MailOffIcon64Regular } from './MailOffIcon64Regular';
var sizes = {
    16: {
        light: MailOffIcon16Light,
        regular: MailOffIcon16Regular,
        solid: MailOffIcon16Solid,
    },
    20: {
        light: MailOffIcon20Light,
        regular: MailOffIcon20Regular,
        solid: MailOffIcon20Solid,
    },
    24: {
        regular: MailOffIcon24Regular,
        solid: MailOffIcon24Solid,
    },
    32: {
        regular: MailOffIcon32Regular,
    },
    64: {
        regular: MailOffIcon64Regular,
    },
};
export var MailOffIcon = forwardRef('MailOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
